import React from "react";
import PlatformRow from "./PlatformRow";
import { formatRand } from "./helpers";

const PlatformDonut = ({ breakdown = {} }) => {
  const uberEarnings = breakdown.uber?.earnings || 0;
  const boltEarnings = breakdown.bolt?.earnings || 0;
  const total = breakdown.total || uberEarnings + boltEarnings;
  const uberPct = total > 0 ? (uberEarnings / total) * 100 : 0;
  const boltPct = total > 0 ? (boltEarnings / total) * 100 : 0;
  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const uberOffset = circumference - (uberPct / 100) * circumference;
  const boltOffset = circumference - (boltPct / 100) * circumference;

  return (
    <div className="p-6 flex-1 flex flex-col md:flex-row gap-10 items-center justify-center">
      <div className="relative w-40 h-40 flex items-center justify-center">
        <svg className="w-full h-full transform -rotate-90" viewBox="0 0 160 160">
          <circle cx="80" cy="80" r={radius} fill="transparent" stroke="#e5e7eb" strokeWidth="12" />
          <circle
            cx="80"
            cy="80"
            r={radius}
            fill="transparent"
            stroke="#6f5383"
            strokeWidth="12"
            strokeDasharray={circumference}
            strokeDashoffset={uberOffset}
            strokeLinecap="round"
          />
          <circle
            cx="80"
            cy="80"
            r={radius}
            fill="transparent"
            stroke="#16a34a"
            strokeWidth="12"
            strokeDasharray={circumference}
            strokeDashoffset={boltOffset}
            strokeLinecap="round"
            style={{ transform: `rotate(${(uberPct / 100) * 360}deg)`, transformOrigin: "50% 50%" }}
          />
        </svg>
        <div className="absolute flex flex-col items-center">
          <p className="text-[10px] font-bold text-gray-400 uppercase">Total</p>
          <p className="text-lg font-bold">{formatRand(total)}</p>
        </div>
      </div>

      <div className="flex-1 w-full space-y-4">
        <PlatformRow letter="U" color="purple" label="Uber Earnings" earnings={uberEarnings} pct={uberPct} />
        <PlatformRow letter="B" color="green" label="Bolt Earnings" earnings={boltEarnings} pct={boltPct} />
      </div>
    </div>
  );
};

export default PlatformDonut;
